import {
  ChangeDetectorRef,
  DestroyRef,
  inject,
  Pipe,
  type PipeTransform,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ObfuscationService,
  type ObfuscationType,
} from '@principle-theorem/ng-management-tools';
import { ValueFormatter } from '@principle-theorem/principle-core';
import { IDataPoint } from '@principle-theorem/reporting';

@Pipe({
  name: 'metric',
  pure: false,
})
export class MetricPipe implements PipeTransform {
  private _obfuscation = inject(ObfuscationService);
  private _cdr = inject(ChangeDetectorRef);
  private _destroyRef = inject(DestroyRef);
  private _lastDataPoint: IDataPoint | null | undefined;
  private _lastIsActive: boolean | undefined;
  private _cachedResult = '';

  constructor() {
    this._obfuscation.isActive$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => this._cdr.markForCheck());
  }

  transform(dataPoint?: IDataPoint | null): string {
    const isActive = this._obfuscation.isActiveSnapshot;
    if (dataPoint === this._lastDataPoint && isActive === this._lastIsActive) {
      return this._cachedResult;
    }
    this._lastDataPoint = dataPoint;
    this._lastIsActive = isActive;

    if (!dataPoint) {
      // eslint-disable-next-line no-console
      console.error('No data point');
      this._cachedResult = '';
      return this._cachedResult;
    }

    if (dataPoint.isPii && isActive) {
      const rawValue = dataPoint.valueLabel ?? dataPoint.value;
      const stringValue = rawValue?.toString() ?? '';
      const piiType: ObfuscationType = dataPoint.piiType ?? 'name';
      this._cachedResult = this._obfuscation.obfuscateByType(
        stringValue,
        piiType
      );
      return this._cachedResult;
    }

    this._cachedResult = ValueFormatter.format(
      dataPoint.valueLabel ?? dataPoint.value,
      dataPoint.formatter,
      dataPoint.formatterValue
    );
    return this._cachedResult;
  }
}
